import { render, staticRenderFns } from "./Vision-general-de-compras.vue?vue&type=template&id=4685cda1&scoped=true"
import script from "./Vision-general-de-compras.vue?vue&type=script&lang=js"
export * from "./Vision-general-de-compras.vue?vue&type=script&lang=js"
import style0 from "./Vision-general-de-compras.vue?vue&type=style&index=0&id=4685cda1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4685cda1",
  null
  
)

export default component.exports